module.exports = __webpack_public_path__ + "img/delivered_w.ad0d920b.png";